var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      ref: "up",
      staticStyle: { display: "inline-block" },
      attrs: {
        title: "最多上传5个附件，单文件最大20M",
        action: "//upload.qiniup.com",
        multiple: "",
        data: _vm.token,
        "before-upload": _vm.beforeUpload,
        "on-success": _vm.uploadSuccess,
        "on-remove": _vm.handleRemove,
        "file-list": _vm.fileList
      }
    },
    [_c("el-button", [_vm._v("上传附件")])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2d3bee0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2d3bee0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketUpload.vue
// module id = 744
// module chunks = 75